import { useEffect, useState } from "react";
import Button from "../../../../../../common/components/xepp/button/Button";
import styles from "./ServiceTypeCard.module.scss";
import { ServiceRequestType } from "../../../../../../model/service-request/service-request";
import {
	useLazyGetServiceRequestQuery,
	usePublishServiceRequestMutation,
	useUnpublishServiceRequestMutation,
} from "../../../../../../service/customersupport-service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setServiceRequestType } from "../../../../../../stores/slices/service-type-slice";
import { ApplicationRoutes } from "../../../../../../routes";
import { getErrorMessage } from "../../../../../../utils/error-handler";
import { hideLoader, showLoader } from "../../../../../../stores/slices/loader-slice";
import { ServiceTypeIcon } from "../../../../../../assets/icons/service-request/ServiceTypeIcon";

interface Props {
	serviceType: ServiceRequestType;
	index: number;
}

const ServiceTypeCard = (props: Props) => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const [dialogOpen, setDialogOpen] = useState(false);

	const [publishServiceRequest, { isLoading: isPublishing }] = usePublishServiceRequestMutation();
	const [unpublishServiceRequest, { isLoading: isUnpublishing }] = useUnpublishServiceRequestMutation();
	const [getServiceRequest, { isLoading: isGettingServiceRequest }] = useLazyGetServiceRequestQuery();

	useEffect(() => {
		if (!dialogOpen) return;
		const handleClick = (e: any) => {
			if (!e.target.closest(`.${styles.dialog}`) && !e.target.closest(`.${styles.actionContainer}`)) {
				setDialogOpen(false);
			}
		};
		document.addEventListener("click", handleClick);
		return () => document.removeEventListener("click", handleClick);
	}, [dialogOpen]);

	const onEditClick = () => {
		const fetchServiceRequest = async () => {
			try {
				const st = await getServiceRequest(props.serviceType.id).unwrap();
				dispatch(setServiceRequestType(st));
				navigator(ApplicationRoutes.EDIT);
			} catch (err: any) {
				getErrorMessage(err.data);
			}
		};
		fetchServiceRequest();
	};

	const publishUnpublishServiceRequest = async () => {
		setDialogOpen(false);
		dispatch(showLoader());

		if (props.serviceType.isPublished) {
			unpublishServiceRequest({ serviceRequestId: props.serviceType.id })
				.unwrap()
				.then(() => {
					toast.success("Service request unpublished");
				})
				.catch(err => toast.error(getErrorMessage(err?.data)))
				.finally(() => {
					dispatch(hideLoader());
				});
		} else {
			publishServiceRequest({ serviceRequestId: props.serviceType.id })
				.unwrap()
				.then(() => {
					toast.success("Service request published");
				})
				.catch(err => toast.error(getErrorMessage(err?.data)))
				.finally(() => {
					dispatch(hideLoader());
				});
		}
	};

	return (
		<>
			<div key={props.index} className={styles.serviceTypeContainer}>
				<div className={styles.imageContainer} aria-hidden="true">
					<ServiceTypeIcon />
				</div>
				<div className={styles.nameContainer}>{props.serviceType.name}</div>
				<div className={styles.descriptionContainer}>{props.serviceType.description}</div>
				<div className={styles.actionContainer}>
					<Button
						text="Manage"
						variant="outline"
						onClick={() => {
							setDialogOpen(!dialogOpen);
						}}
					/>
					{dialogOpen && (
						<>
							{/* <div className={styles.dialogBackdrop} onClick={() => { setDialogOpen(!dialogOpen) }} /> */}
							<div className={styles.dialog}>
								<div
									className={styles.dialogOption}
									onClick={() => {
										navigator(`${props.serviceType.id}/${ApplicationRoutes.INSTANCES}`);
									}}
								>
									View Requests
								</div>
								{/* EKEDC: SR type manipulation disabled - statical SR definitions submitted through UI
								<div className={styles.dialogOption} onClick={publishUnpublishServiceRequest}>
									{props.serviceType.isPublished ? "Unpublish" : "Publish"}
								</div>
								<div className={styles.dialogOption} onClick={onEditClick}>
									Edit
								</div>
								*/}
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default ServiceTypeCard;
